<template>
  <div style="display: none;"></div>
</template>

<script setup>
import { getFirestore, collection, getDocs, doc, deleteDoc } from "firebase/firestore";
import { onMounted } from "vue";

const db = getFirestore();

const cleanupOldReservations = async () => {
  try {
    const now = new Date();
    const cutoffTime = new Date(now.getTime() - 30 * 60 * 1000); // 30 minutes ago

    // Query for all reservations (no status filter to catch missing/null status)
    const reservationsRef = collection(db, "reservations");
    const snapshot = await getDocs(reservationsRef);
    
    if (!snapshot.empty) {
      // Filter for reservations that should be deleted
      const reservationsToDelete = snapshot.docs.filter(docSnapshot => {
        const data = docSnapshot.data();
        const status = data.status;
        const createdAt = data.createdAt;
        
        // Check if status is pending, null, undefined, or doesn't exist
        const shouldDeleteByStatus = !status || status === null || status === "pending";
        
        // Check if it's older than 30 minutes
        let shouldDeleteByTime = false;
        if (createdAt) {
          const createdAtDate = createdAt.toDate ? createdAt.toDate() : new Date(createdAt);
          shouldDeleteByTime = createdAtDate < cutoffTime;
        }
        
        // Delete if status is invalid AND it's old enough
        return shouldDeleteByStatus && shouldDeleteByTime;
      });

      if (reservationsToDelete.length > 0) {
        const deletePromises = reservationsToDelete.map(docSnapshot => 
          deleteDoc(doc(db, "reservations", docSnapshot.id))
        );
        
        await Promise.all(deletePromises);
        console.log(`🧹 Cleaned up ${deletePromises.length} old reservations (pending/null/missing status)`);
      }
    }
  } catch (error) {
    console.error("Error cleaning up old reservations:", error);
  }
};

onMounted(() => {
  // Run cleanup when component mounts
  cleanupOldReservations();
});
</script> 